import p1_img from './product_1.jpg';
import p2_img from './product_2.jpg';
import p3_img from './product_3.jpg';
import p4_img from './product_4.jpg';
import p5_img from './product_5.webp';
import p6_img from './product_6.webp';
import p7_img from './product_7.webp';
import p8_img from './product_8.webp';
import p9_img from './product_9.jpg';
import p10_img from './product_10.jpg';
import p11_img from './product_11.png';
import p12_img from './product_12.jpg';
import p13_img from './product_13.png';
import p14_img from './product_14.png';
import p15_img from './product_15.jpg';
import p16_img from './product_16.jpeg';
import p17_img from './product_17.png';
import p18_img from './product_18.png';
import p19_img from './product_19.png';
import p20_img from './product_20.png';
import p21_img from './product_21.png';
import p22_img from './product_22.png';
import p23_img from './product_23.png';
import p24_img from './product_24.png';
import p25_img from './product_25.png';
import p26_img from './product_26.png';
import p27_img from './product_27.png';
import p28_img from './product_28.jpg';
import p29_img from './product_29.jpg';
import p30_img from './product_30.jpg';
import p31_img from './product_31.jpg';
import p32_img from './product_32.jpg';
import p33_img from './product_33.jpg';
import p34_img from './product_34.jpg';
import p35_img from './product_35.jpg';
import p36_img from './product_36.jpg';

const all_product = [
  // medical - diagnostic-devices
  {
    id: 1,
    category: "medical",
    subCategory: "diagnostic-devices",
    name: "Digital Thermometer",
    new_price: 120,
    old_price: 150,
    description: "Fast and accurate digital thermometer with LCD display.",
    image: p1_img
  },
  {
    id: 2,
    category: "medical",
    subCategory: "diagnostic-devices",
    name: "Blood Pressure Monitor",
    new_price: 320,
    old_price: 380,
    description: "Automatic BP monitor with cuff and memory tracking.",
    image: p2_img
  },
  {
    id: 3,
    category: "medical",
    subCategory: "diagnostic-devices",
    name: "Pulse Oximeter",
    new_price: 150,
    old_price: 180,
    description: "Measures blood oxygen levels and heart rate instantly.",
    image: p3_img
  },

  // medical - surgical-instruments
  {
    id: 4,
    category: "medical",
    subCategory: "surgical-instruments",
    name: "Scalpel Set",
    new_price: 270,
    old_price: 320,
    description: "High-precision stainless steel scalpel set.",
    image: p4_img
  },
  {
    id: 5,
    category: "medical",
    subCategory: "surgical-instruments",
    name: "Surgical Scissors",
    new_price: 190,
    old_price: 230,
    description: "Curved and straight scissors for surgical use.",
    image: p5_img
  },
  {
    id: 6,
    category: "medical",
    subCategory: "surgical-instruments",
    name: "Forceps Kit",
    new_price: 210,
    old_price: 250,
    description: "Assorted forceps for medical and lab applications.",
    image: p6_img
  },

  // lab - glassware
  {
    id: 7,
    category: "lab",
    subCategory: "glassware",
    name: "Beaker Set (100ml-1000ml)",
    new_price: 250,
    old_price: 300,
    description: "Heat-resistant borosilicate beakers for lab use.",
    image: p7_img
  },
  {
    id: 8,
    category: "lab",
    subCategory: "glassware",
    name: "Measuring Cylinder",
    new_price: 100,
    old_price: 130,
    description: "Graduated cylinder for accurate liquid measurement.",
    image: p8_img
  },
  {
    id: 9,
    category: "lab",
    subCategory: "glassware",
    name: "Test Tube Set",
    new_price: 80,
    old_price: 100,
    description: "Pack of 12 test tubes with rack and brush.",
    image: p9_img
  },

  // lab - electronic-devices
  {
    id: 10,
    category: "lab",
    subCategory: "electronic-devices",
    name: "Centrifuge Machine",
    new_price: 950,
    old_price: 1100,
    description: "Tabletop centrifuge for blood and sample separation.",
    image: p10_img
  },
  {
    id: 11,
    category: "lab",
    subCategory: "electronic-devices",
    name: "Hot Plate Stirrer",
    new_price: 600,
    old_price: 720,
    description: "Magnetic stirrer with adjustable temperature control.",
    image: p11_img
  },
  {
    id: 12,
    category: "lab",
    subCategory: "electronic-devices",
    name: "Digital Microscope",
    new_price: 1300,
    old_price: 1500,
    description: "USB microscope with up to 1000x magnification.",
    image: p12_img
  },

  // reagent - biochemical-reagents
  {
    id: 13,
    category: "reagent",
    subCategory: "biochemical-reagents",
    name: "Protein Assay Kit",
    new_price: 450,
    old_price: 520,
    description: "Complete BCA protein quantification kit.",
    image: p13_img
  },
  {
    id: 14,
    category: "reagent",
    subCategory: "biochemical-reagents",
    name: "DNA Extraction Kit",
    new_price: 750,
    old_price: 850,
    description: "For rapid and pure DNA isolation from cells.",
    image: p14_img
  },
  {
    id: 15,
    category: "reagent",
    subCategory: "biochemical-reagents",
    name: "ELISA Kit",
    new_price: 980,
    old_price: 1150,
    description: "Enzyme-linked immunosorbent assay kit for research.",
    image: p15_img
  },

  // reagent - stains-indicators
  {
    id: 16,
    category: "reagent",
    subCategory: "stains-indicators",
    name: "Methylene Blue",
    new_price: 140,
    old_price: 170,
    description: "Biological stain for microscopy and cell observation.",
    image: p16_img
  },
  {
    id: 17,
    category: "reagent",
    subCategory: "stains-indicators",
    name: "Iodine Solution",
    new_price: 110,
    old_price: 135,
    description: "Used as a starch indicator in experiments.",
    image: p17_img
  },
  {
    id: 18,
    category: "reagent",
    subCategory: "stains-indicators",
    name: "Phenolphthalein",
    new_price: 160,
    old_price: 190,
    description: "pH indicator used in titration and experiments.",
    image: p18_img
  },

  // chemical - acids
  {
    id: 19,
    category: "chemical",
    subCategory: "acids",
    name: "Hydrochloric Acid 1M",
    new_price: 220,
    old_price: 260,
    description: "Lab-grade HCl solution, 500ml bottle.",
    image: p19_img
  },
  {
    id: 20,
    category: "chemical",
    subCategory: "acids",
    name: "Sulfuric Acid 2M",
    new_price: 250,
    old_price: 290,
    description: "High-purity H₂SO₄ for analytical use.",
    image: p20_img
  },
  {
    id: 21,
    category: "chemical",
    subCategory: "acids",
    name: "Nitric Acid 1M",
    new_price: 230,
    old_price: 270,
    description: "Concentrated HNO₃ solution for lab work.",
    image: p21_img
  },

  // chemical - bases
  {
    id: 22,
    category: "chemical",
    subCategory: "bases",
    name: "Sodium Hydroxide Pellets",
    new_price: 180,
    old_price: 210,
    description: "Analytical grade NaOH pellets, 250g pack.",
    image: p22_img
  },
  {
    id: 23,
    category: "chemical",
    subCategory: "bases",
    name: "Ammonium Hydroxide",
    new_price: 200,
    old_price: 240,
    description: "NH₄OH aqueous solution, 500ml bottle.",
    image: p23_img
  },
  {
    id: 24,
    category: "chemical",
    subCategory: "bases",
    name: "Calcium Hydroxide",
    new_price: 160,
    old_price: 190,
    description: "Also known as slaked lime, fine white powder.",
    image: p24_img
  },

  // chemical - solvents
  {
    id: 25,
    category: "chemical",
    subCategory: "solvents",
    name: "Ethanol 95%",
    new_price: 290,
    old_price: 340,
    description: "Laboratory-grade ethyl alcohol, 500ml.",
    image: p25_img
  },
  {
    id: 26,
    category: "chemical",
    subCategory: "solvents",
    name: "Acetone",
    new_price: 270,
    old_price: 310,
    description: "Common lab solvent for cleaning and reactions.",
    image: p26_img
  },
  {
    id: 27,
    category: "chemical",
    subCategory: "solvents",
    name: "Methanol",
    new_price: 310,
    old_price: 360,
    description: "Highly pure CH₃OH solvent, 500ml.",
    image: p27_img
  },

  // chemical - salts
  {
    id: 28,
    category: "chemical",
    subCategory: "salts",
    name: "Sodium Chloride",
    new_price: 90,
    old_price: 110,
    description: "Laboratory NaCl, 500g analytical grade.",
    image: p28_img
  },
  {
    id: 29,
    category: "chemical",
    subCategory: "salts",
    name: "Potassium Nitrate",
    new_price: 200,
    old_price: 240,
    description: "Oxidizing agent for chemical experiments.",
    image: p29_img
  },
  {
    id: 30,
    category: "chemical",
    subCategory: "salts",
    name: "Calcium Carbonate",
    new_price: 150,
    old_price: 180,
    description: "Lab-grade CaCO₃, white powder, 250g.",
    image: p30_img
  },
  {
    id: 31,
    category: "chemical",
    subCategory: "salts",
    name: "Sodium Bicarbonate",
    new_price: 100,
    old_price: 120,
    description: "Commonly used buffer and pH stabilizer.",
    image: p31_img
  },
  {
    id: 32,
    category: "chemical",
    subCategory: "salts",
    name: "Magnesium Sulfate",
    new_price: 170,
    old_price: 200,
    description: "Also known as Epsom salt, 500g.",
    image: p32_img
  },
  {
    id: 33,
    category: "chemical",
    subCategory: "salts",
    name: "Zinc Oxide",
    new_price: 220,
    old_price: 260,
    description: "White powder used in various chemical processes.",
    image: p33_img
  },
  {
    id: 34,
    category: "chemical",
    subCategory: "salts",
    name: "Ferric Chloride",
    new_price: 260,
    old_price: 300,
    description: "Etching and coagulant agent, FeCl₃.",
    image: p34_img
  },
  {
    id: 35,
    category: "chemical",
    subCategory: "salts",
    name: "Ammonium Sulfate",
    new_price: 200,
    old_price: 230,
    description: "White crystalline salt used in lab prep.",
    image: p35_img
  },
  {
    id: 36,
    category: "chemical",
    subCategory: "salts",
    name: "Copper Sulfate",
    new_price: 310,
    old_price: 360,
    description: "Laboratory reagent, CuSO₄, 500g pack.",
    image: p36_img
  }
];

export default all_product;